import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import styles from './QuestionPreview.module.scss'
import { Box } from 'components/layout/Box/Box'
import { List } from 'components/shared/List/List'

export const QuestionPreview = ({ id, count, total, title, description }) => (
  <List.Item className={styles.item} key={id}>
    {count && <span className={styles.count}>{t`${count} of ${total}`}</span>}
    <h3 className={styles.title}>{title}</h3>
    {R.gt(R.length(description), 0) ? (
      <Box className={styles.container} direction="column">
        <p className={styles.description}>{description}</p>
      </Box>
    ) : null}
  </List.Item>
)
